(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const isPDPMode = urlParams.get('pdp') === 'true';
  const formContainer = document.querySelector('[data-product-selector]');
  const divider = document.querySelector('[data-product-selector-divider]');
  if (!formContainer || !divider) return;

  if (!isPDPMode) {
    divider.classList.add('hidden');
    formContainer.classList.remove('hidden');
  }
})();
